{
  "aboutProject": "Om prosjektet",
  "accountSettings": "Kontoinnstillingar",
  "activities": "Aktivitetar",
  "activity": "Aktivitetar",
  "application": "Søknad",
  "areasOfInterest": "Interesseområde",
  "chooseCluster": "Velg nettverk",
  "cluster": "Klynga",
  "clusterManagement": "Leiing",
  "clusterOperation": "Klyngedrift",
  "clusterVisionMission": "Nettverkets visjon og misjon",
  "companyInformation": "Selskapsinformasjon",
  "contactInformation": "Kontaktinformasjon",
  "contacts": "Kontakter",
  "coreData": "Grunndata",
  "economy": "Økonomi",
  "events": "Eventer",
  "financing": "Finansiering",
  "focusAreas": "Fokusområde",
  "goalAccomplishment": "Årets måloppnåing",
  "graphical": "Lag ein eigen inngang til Éin veg inn",
  "home": "Heim",
  "hourlyRate": "Timesats",
  "inFinancedProjects": "Prosjekt finansiert av Innovasjon Noreg",
  "mainGoal": "Hovudmål",
  "memberCompanySelfEffortOverview": "Oversikt over medlemsbedrifta sin eigeninnsats",
  "memberInformation": "Medlemsinformasjon",
  "customers": "Kunder",
  "membershipFee": "Medlemskontingent",
  "membershipFeesAndSelfEffort": "Medlemsbidrag og eigeninnsats",
  "opportunities": "Henvendelser",
  "opportunitiesHeader": "Behandle henvendingar fra kunder",
  "overview": "Oversikt",
  "ownProjects": "Eigne prosjekt",
  "participants": "Deltakarar",
  "portal": "Fleirbedriftsportalen",
  "projectCategories": "Prosjektkategoriar",
  "projectDetail": "Prosjektdetaljar",
  "Projects": "Prosjekt",
  "projects": "Prosjekt",
  "reports": "Rapportar",
  "resourceBase": "Kunderegister",
  "selfEffort": "Eigeninnsats",
  "selfEffortContactOverview": "Oversikt over kontaktas eigeninnsats",
  "selfEffortOverview": "Oversikt eigeninnsats",
  "statistics": "Statistikk",
  "subProjects": "Delprosjekt",
  "visionMission": "Visjon og misjon",
  "yourProfile": "Profilen din",
  "assignments": "Oppgåver",
  "allMeetings": "Alle møte",
  "allEvents": "Alle eventer",
  "sivaContacts": "Kontakter",
  "sivaReporting": "Rapportering",
  "sivaReporting.Header": "Rapportere og følgje opp",
  "sivaDataExtract": "Datauttrekk",
  "myContactInformation": "Min kontaktinfo",
  "editMyContactInformation": "Rediger min kontaktinformasjon",
  "actorProfile": "Aktørprofil",
  "settings": "Innstillinger",
  "editAccessControls": "Rediger tilgangar",
  "editMailSettings": "Rediger e-postvarslar",
  "targetedCompanies": "Målbedrifter",
  "ideasAndCompaniesHeader": "Arbeid med idéer, bedrifter og alumni",
  "frontPage": "Forside",
  "services": "Tenestekatalog",
  "services.Header": "Se og registrere tenester",
  "invoices": "Fakturering"
}
